"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayProgramSectionModel = exports.DayProgramModel = void 0;
var class_validator_1 = require("class-validator");
var ContentModel_1 = require("./ContentModel");
var DayProgramModel = /** @class */ (function () {
    function DayProgramModel() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsInt(),
        class_validator_1.Min(0),
        class_validator_1.Max(2147483647),
        __metadata("design:type", Object)
    ], DayProgramModel.prototype, "sortOrder", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], DayProgramModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DayProgramModel.prototype, "title", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], DayProgramModel.prototype, "active", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], DayProgramModel.prototype, "imageId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], DayProgramModel.prototype, "image", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], DayProgramModel.prototype, "categories", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], DayProgramModel.prototype, "subCategories", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], DayProgramModel.prototype, "sections", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DayProgramModel.prototype, "help", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DayProgramModel.prototype, "content", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], DayProgramModel.prototype, "likes", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], DayProgramModel.prototype, "dislikes", void 0);
    return DayProgramModel;
}());
exports.DayProgramModel = DayProgramModel;
var DayProgramSectionModel = /** @class */ (function () {
    function DayProgramSectionModel() {
    }
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], DayProgramSectionModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], DayProgramSectionModel.prototype, "dayProgramId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], DayProgramSectionModel.prototype, "content", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], DayProgramSectionModel.prototype, "imageId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], DayProgramSectionModel.prototype, "image", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], DayProgramSectionModel.prototype, "position", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], DayProgramSectionModel.prototype, "section", void 0);
    __decorate([
        class_validator_1.IsIn(ContentModel_1.CONTENT_SECTIONS),
        __metadata("design:type", String)
    ], DayProgramSectionModel.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DayProgramSectionModel.prototype, "linkText", void 0);
    return DayProgramSectionModel;
}());
exports.DayProgramSectionModel = DayProgramSectionModel;
//# sourceMappingURL=DayProgramModel.js.map